export default __webpack_public_path__ + "static/media/element_spec_1.3292ded7.webp";